import { Skeleton } from '@mantine/core';
import { useState } from 'react';
import type { GetTestRunAttemptType, GetTestRunType } from '~/server/api/routers/testRun';
import TestRunAttemptSwitcher from '~/components/testRun/TestRunAttemptSwitcher';
import ExecutionViewer from '~/components/testRun/ExecutionView/ExecutionViewer';

const ExecutionViewSkeleton = () => (
  <div className="space-y-4">
    <div className="flex items-start justify-between space-x-6">
      <div className="flex flex-col space-y-1">
        <Skeleton
          height={20}
          width={120}
          radius="md"
        />
        <Skeleton
          height={16}
          width={80}
          radius="md"
        />
      </div>
      <Skeleton
        height={30}
        width={80}
        radius="md"
      />
    </div>
    <Skeleton
      height="60vh"
      radius="md"
    />
  </div>
);

export default function TestRunExecutionViewTab({
  isTestRunLoading,
  testRun,
  isFullView,
}: {
  isTestRunLoading: boolean;
  testRun: GetTestRunType;
  isFullView?: boolean;
}) {
  const [selectedTestRunAttempt, setSelectedTestRunAttempt] = useState<GetTestRunAttemptType | undefined>();
  const testRunAttempts = testRun?.TestRunAttempts || [];

  return (
    <div className="mt-4 h-full">
      {isTestRunLoading ?
        <ExecutionViewSkeleton />
      : testRun ?
        <div className="space-y-4">
          <div className="flex items-start gap-6">
            {testRun.status !== 'SKIPPED' && testRunAttempts.length > 0 && (
              <TestRunAttemptSwitcher
                testRunAttempts={testRunAttempts}
                isFullView={isFullView}
                onAttemptChange={setSelectedTestRunAttempt}
                runStatus={testRun.status}
              />
            )}
          </div>

          <ExecutionViewer
            outputSteps={selectedTestRunAttempt?.outputTestContent?.steps ?? []}
            inputSteps={selectedTestRunAttempt?.inputTestContent?.steps ?? []}
            testRunOutput={
              selectedTestRunAttempt?.executionOutput ?? {
                aiChanges: [],
                errors: [],
                logs: [],
                conditionalBlockResults: [],
                erroredAutoHealableOperations: [],
                aiActionLogs: [],
              }
            }
            inputContentId={
              selectedTestRunAttempt?.inputTestContentId ? selectedTestRunAttempt.inputTestContentId : undefined
            }
            trunkContentId={testRun.test?.trunkContentId ?? undefined}
            testId={testRun.testId ?? undefined}
          />
        </div>
      : <div className="mt-4">No execution trace available.</div>}
    </div>
  );
}
